import type { QuoteSectionModuleProps } from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

export function QuoteSectionModule({
  eyebrow,
  quote,
  attributionName,
  attributionTitle,
  layout = "LEFT",
  image,
  ctaLabel,
  ctaUrl,
}: QuoteSectionModuleProps) {
  const normalizedLayout = layout === "CENTERED" ? "CENTERED" : "LEFT";
  const isCentered = normalizedLayout === "CENTERED";
  const renderImage = isCentered ? undefined : image;

  return (
    <section
      className={[
        "cms-section",
        "cms-quote-section",
        "cms-tone-dark",
        `cms-quote-section--layout-${isCentered ? "centered" : "left"}`,
        renderImage ? "" : "cms-quote-section--no-image",
      ]
        .filter(Boolean)
        .join(" ")}
      data-cms-module="quote-section"
    >
      <div className="cms-wrap cms-quote-section__layout">
        {renderImage ? (
          <figure className="cms-quote-section__image">
            <img src={renderImage.src} alt={renderImage.alt} />
            {renderImage.caption ? <figcaption>{renderImage.caption}</figcaption> : null}
          </figure>
        ) : null}
        <div className="cms-quote-section__content">
          <div className="cms-eyebrow-row">
            <span className="cms-eyebrow">
              {renderTextWithLineBreaks(eyebrow || "Perspective")}
            </span>
          </div>
          <blockquote>{renderTextWithLineBreaks(quote)}</blockquote>
          {attributionName || attributionTitle ? (
            <p className="cms-quote-section__attribution">
              {attributionName ? <strong>{attributionName}</strong> : null}
              {attributionTitle ? (
                <span>{renderTextWithLineBreaks(attributionTitle)}</span>
              ) : null}
            </p>
          ) : null}
          {ctaLabel && ctaUrl ? (
            <a className="cms-text-link cms-text-link--on-dark" href={ctaUrl} rel="noopener noreferrer">
              {ctaLabel}
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
}
